import { useState, useEffect } from 'react'
import type { NavId } from '../types'

const NAV_TO_PATH: Record<NavId, string> = {
  overview:     '/dashboard',
  transactions: '/transactions',
  cards:        '/cards',
  annual:       '/annual',
  goals:        '/goals',
  settings:     '/settings',
  admin:        '/admin',
}

const PATH_TO_NAV: Record<string, NavId> = Object.fromEntries(
  Object.entries(NAV_TO_PATH).map(([k, v]) => [v, k as NavId])
)

export function useRouter() {
  const [active, setActive] = useState<NavId>(() => {
    return PATH_TO_NAV[window.location.pathname] ?? 'overview'
  })

  function navigate(navId: NavId) {
    window.history.pushState({}, '', NAV_TO_PATH[navId])
    setActive(navId)
  }

  useEffect(() => {
    const handler = () => {
      setActive(PATH_TO_NAV[window.location.pathname] ?? 'overview')
    }
    window.addEventListener('popstate', handler)
    return () => window.removeEventListener('popstate', handler)
  }, [])

  return { active, navigate, setActive }
}
